<template>
  <footer class="footer">
    <div class="container footer-main">
      <div class="footer-brand">
        <div class="brand footer-brand-lockup">
          <span class="brand-mark">G</span>
          <span class="brand-copy">
            <strong>GEON</strong>
            <small>CONSULTS</small>
          </span>
        </div>
        <p>Practical financial insight and business guidance for organisations ready to operate with clarity and confidence.</p>
        <div class="socials">
          <a href="#" aria-label="LinkedIn">in</a>
          <a href="#" aria-label="Instagram">ig</a>
          <a href="#" aria-label="Facebook">f</a>
        </div>
      </div>

      <div class="footer-col">
        <h4>Company</h4>
        <a href="#about">About Jomass</a>
        <a href="#services">Our Services</a>
        <a href="#industries">Industries</a>
        <a href="#insights">Insights</a>
      </div>

      <div class="footer-col">
        <h4>Services</h4>
        <a href="#services">Accounting</a>
        <a href="#services">Tax & Compliance</a>
        <a href="#services">Audit & Assurance</a>
        <a href="#services">Business Consulting</a>
      </div>

      <div class="footer-col footer-contact">
        <h4>Get in touch</h4>
        <p>Port Harcourt, Rivers State, Nigeria</p>
        <a href="mailto:info@jomass.com">info@jomass.com</a>
        <a href="tel:+2348000000000">+234 800 000 0000</a>
      </div>
    </div>

    <div class="container footer-bottom">
      <span>© {{ year }} Jomass Accounting Firm / Business Consultants. All rights reserved.</span>
      <div>
        <a href="#">Privacy Policy</a>
        <a href="#">Terms of Use</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter',
  computed: {
    year() {
      return new Date().getFullYear()
    }
  }
}
</script>